// The API reports an ad-platform user without the role/scope to write
// audiences with a stable code (synchronous LinkedIn check) or with a job
// result reason (Google/Meta contacts jobs). Both map to the same message.
export const LINKEDIN_ADS_CAPABILITY_REQUIRED_CODE = "LINKEDIN_ADS_CAPABILITY_REQUIRED";
export const AUDIENCE_PERMISSION_DENIED_REASON = "ad_account_permission_denied";

export function isAdSyncPermissionError(error) {
  const code = error?.code || error?.response?.data?.code;
  return code === LINKEDIN_ADS_CAPABILITY_REQUIRED_CODE;
}

export function isAdSyncPermissionResult(result) {
  return result?.reason === AUDIENCE_PERMISSION_DENIED_REASON;
}

export function getAdSyncPermissionMessage(t, network) {
  return t("toastMessages.adSync.permissionDenied", { network });
}
